import BuyTickets from "./BuyTickets";

const PopUp = (() => {
  /* =========== private methods =========== */
  let popUpContainer,
    popupBackground,
    html,
    popupCloseButton;

  const cacheDOM = () => {

    popUpContainer = document.getElementsByClassName('christmas-popup')[0];
    if (popUpContainer) {
      popupCloseButton = popUpContainer.getElementsByClassName('christmas-popup__content--close')[0];
      popupBackground  = popUpContainer.getElementsByClassName('christmas-popup__bg')[0];
      html					   = document.querySelector( "html" );
    }
  }

  const closePopup = () => {
    popUpContainer.classList.remove('is-visible');
    html.classList.remove('popup-open');
  }

  const popupActive = () => {
    html.classList.add('popup-open');
  }

  const setupEventListeners = () => {
    popupCloseButton.addEventListener("click", closePopup);
    popupBackground.addEventListener("click", closePopup);
  }

  const init = () => {
    cacheDOM();

    if (popUpContainer) {
      popupActive();
      setupEventListeners();
    }
  }

  return { init };
})();

export default PopUp;
